import {Bank} from './types';

export enum BankActionTypes {
    SetBank = 'Bank/SetBank',
}

export type BankActions =
    | { type: BankActionTypes.SetBank, bank: Bank };
